export const INVESTMENT_EXPERIENCE_VALUES = [
  "none",
  "limited",
  "intermediate",
  "sophisticated",
  "1_to_5_years",
  "over_5_years",
] as const;

export const OPTIONS_DOCS_URL =
  "https://docs.alpaca.markets/docs/options-trading";

export const OPTIONS_LEARN_URL =
  "https://alpaca.markets/learn/search?category=trading-api&topic=options/";

export const OPTIONS_YOUTUBE_URL =
  "https://www.youtube.com/watch?v=B0Z7oCmr5nM&list=PLfVbHYUC5FiI1VbMZar1_TX5dvyDPnHSJ";

export const MARITAL_STATUS_VALUES = [
  "SINGLE",
  "MARRIED",
  "DIVORCED",
  "WIDOWED",
] as const;
